
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.726 3.426c2.436.245 4.39 1.71 4.807 4.224h-1.41l2.276 3.386 2.277-3.386h-1.57c-.418-3.385-2.981-5.586-6.22-5.9-.448-.035-.864.349-.864.838.03.42.318.802.704.838zM11.2 1.715H3.285c-.448 0-.8.384-.8.873v7.54c0 .49.352.873.8.873h7.916c.448 0 .8-.384.8-.873v-7.54c0-.49-.352-.873-.8-.873zM9.66 20.916c-2.723-.244-4.807-2.06-4.903-5.062h1.506L3.99 12.468l-2.275 3.386H3.22c.063 3.876 2.787 6.388 6.282 6.738.448.034.865-.35.865-.839a.835.835 0 00-.706-.837zm11.476-7.576H13.22c-.45 0-.801.385-.801.873v7.576c0 .488.35.872.8.872h7.916c.449 0 .8-.384.8-.872v-7.576c.001-.488-.383-.873-.798-.873z","fill":"#282828"}})])
          )
        }
      }
    